module.exports = __webpack_public_path__ + "static/toggl-track-features-f15738c188ec86d5e88d58a24e4df2de.jpg";